import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    maxWidth: "95%", // Responsive for mobile
    zIndex: 1050,
    padding: "20px",
  },
  overlay: {
    zIndex: 1040,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const ConfirmModal = ({
  isOpen,
  onRequestClose,
  contentLabel = "Confirmation Modal",
  onClose = () => { },
  setIsConfirmDelete = () => { },
  title = "Are you sure you want to proceed?",
  icon
}) => {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div className="flex flex-col justify-center py-6 gap-3">
        <div className="flex justify-center">{icon}</div>
        <p className="mb-4 text-black dark:text-black flex justify-center font-medium">
          {title}
        </p>
        <div className="flex justify-center items-center gap-4">
          <button
            aria-label="Cancel operation"
            data-modal-toggle="deleteModal"
            type="button"
            className="py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:outline-none hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            aria-label="Confirm operation"
            type="submit"
            className="py-2 px-3 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-green-800 focus:outline-none"
            onClick={() => setIsConfirmDelete(true)}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
